import React from 'react'

import { AppLibraryProvider } from './AppLibraryProvider.component'
import { AppRoutes } from './AppRoutes.component'

export function App() {
  return (
    <AppLibraryProvider>
      <AppRoutes />
    </AppLibraryProvider>
  )
}
